import { ComponentType, FC } from 'react';
import { Badge, Typography } from '@mui/material';

import { TripTypeEnum } from '@mopla/data-models';

import BusIcon from '../../icons/bus.svg';
import BusWithPeopleIcon from '../../icons/busWithPeople.svg';
import PRODTIcon from '../../icons/prodt.svg';
import RufbusIcon from '../../icons/rufbus.svg';
import WalkIcon from '../../icons/walk.svg';

import { SymbolCircleV2 } from './TravelTypeSymbolsV2.styles';

interface IConfig {
	TransportIcon: ComponentType;
	testId: string;
}

const mapTransportTypeToConfig: Record<TripTypeEnum, IConfig> = {
	[TripTypeEnum.WALK]: {
		TransportIcon: WalkIcon,
		testId: 'travelType-symbols-walk',
	},
	[TripTypeEnum.TRANSFER_WALK]: {
		TransportIcon: WalkIcon,
		testId: 'travelType-symbols-walk',
	},
	[TripTypeEnum.LBT]: {
		TransportIcon: BusIcon,
		testId: 'travelType-symbols-lbt',
	},
	[TripTypeEnum.LBODT]: {
		TransportIcon: RufbusIcon,
		testId: 'travelType-symbols-lbodt',
	},
	[TripTypeEnum.LBODTFLEX]: {
		TransportIcon: BusWithPeopleIcon,
		testId: 'travelType-symbols-lbodtFlex',
	},
	[TripTypeEnum.PRODT]: {
		TransportIcon: PRODTIcon,
		testId: 'travelType-symbols-prodt',
	},

	/** Those are added for the compatibility reasons, so every enum's option has a default render icon */
	[TripTypeEnum.OTHERS]: {
		TransportIcon: WalkIcon,
		testId: 'travelType-symbols-walk',
	},
	[TripTypeEnum.BLOCKER]: {
		TransportIcon: WalkIcon,
		testId: 'travelType-symbols-walk',
	},
	[TripTypeEnum.EMPTY]: {
		TransportIcon: WalkIcon,
		testId: 'travelType-symbols-walk',
	},
	[TripTypeEnum.SPECIAL_SCHOOL_TRAFFIC]: {
		TransportIcon: WalkIcon,
		testId: 'travelType-symbols-walk',
	},
	[TripTypeEnum.LBODTDS]: {
		TransportIcon: WalkIcon,
		testId: 'travelType-symbols-walk',
	},
	[TripTypeEnum.POOLODT]: {
		TransportIcon: WalkIcon,
		testId: 'travelType-symbols-walk',
	},
	[TripTypeEnum.UNCATEGORIZED]: {
		TransportIcon: WalkIcon,
		testId: 'travelType-symbols-walk',
	},
};

export interface INewTransportCircleProps {
	className?: string;
	transportType: TripTypeEnum;
	variant?: 'midGrey' | 'main' | 'disabled';
	large?: boolean;
	duration?: number;
}

export const TransportCircleV2: FC<INewTransportCircleProps> = ({
	className,
	transportType,
	variant = 'main',
	large = false,
	duration,
}) => {
	const { TransportIcon, testId } = mapTransportTypeToConfig[transportType];

	const content = (
		<SymbolCircleV2
			className={className}
			variant={variant}
			large={large}
			data-testid={testId}
		>
			<TransportIcon />
		</SymbolCircleV2>
	);

	return duration ? (
		<Badge
			badgeContent={
				<Typography
					sx={{
						fontSize: '10px',
						lineHeight: '24px',
						fontWeight: 700,
						fontFamily: 'Poppins',
					}}
				>
					{duration}
				</Typography>
			}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
			color="primary"
			overlap="circular"
		>
			{content}
		</Badge>
	) : (
		content
	);
};
